import { render } from "./Widget13.vue?vue&type=template&id=03a38fa2"
import script from "./Widget13.vue?vue&type=script&lang=js"
export * from "./Widget13.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__